module.exports = __webpack_public_path__ + "img/misja-1050x630.e774f64d.jpg";